import React, { FC } from 'react';
// tslint:disable-next-line:prettier
import type { InputNumberProps } from 'antd';

import { InputNumber as AntInputNumber } from 'antd';

import FormGroup, { IPropsText as IFormGroupTextProps } from '../components/FormGroup';
interface IInputProps {
  name: string;
  valid?: boolean;
  onChange?: any;
  value?: any;
}

export type IProps = IFormGroupTextProps & IInputProps & InputNumberProps;


const InputNumber: FC<IProps> = ({ label, tooltip, description, valid, name, onChange, ...props }) => {
  const handleChange = (value: any) => {
    onChange({ target: { name, value } });
  };

  return (
    <FormGroup label={label} description={description} tooltip={tooltip} valid={valid}>
      <AntInputNumber onChange={handleChange} {...props} />
    </FormGroup>
  );
};

export default InputNumber;
